import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Archives from "../../components/layout/archive/Archives";
import {withRouter} from "react-router-dom";
import Breadcrumb from "../../components/layout/Breadcrumb";


class Archive extends React.Component {

  render() {

    const {
      intl: { messages },
      appIntl,
    } = this.props;


    return (
      <>
        <div style={{padding:"25px 0px 0px 25px"}}>
          <Breadcrumb
            crumbs={[
              { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
              { link: appIntl.urlPrefix + 'account/archive', name: "Archive" },

            ]}
            className="p-t-0"
          />
        </div>

        <Archives />
      </>
    );
  }
}

Archive.defaultProps = {

};

const mapStateToProps = state => {
  return {
    user: state.login.user,
    appIntl: state.intl,
  };
};

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,

    )(Archive)
  )
);
